import { styled } from '@mui/material/styles';

import { Box } from '../../../../components/atoms/Box';
import { Typography } from '../../../../components/atoms/Typography';

export const ContentWrapperBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 800px;
  width: 100%;
  border: 1px solid #000;
  background-color: white;
  border-radius: 10px;
  padding: 25px;
`;

export const HeadingWrapper = styled(Typography)`
  padding-bottom: 20px;
`;